import Navbar from "../Navbar";
import LandingFooter from "../LandingFooter";

const Layout = ({ children }) => {
  return (
    <div
      className="layout"
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh", 
      }}
    >
      {/* Navbar */}
      <div className="navbarStyle">
        <Navbar />
      </div>

      {/* Page Content */}
      <div
        className="otherPage"
        style={{
          flex: 1, 
        }}
      >
        <div className="pages">{children}<LandingFooter/></div>
      </div>

      {/* Footer */}
      <div>
        
      </div>
    </div>
  );
};

export default Layout;
